import {inject} from 'aurelia-framework';
import {ApiClient} from "../api-client";

@inject(ApiClient)
export class LoggingErrorRenderer {
  apiClient;

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  render(message, details = null, stack = null, error) {
    // If error originated in backend, don't send it to backend AGAIN.
    if (error && error.name === 'ApiError') {
      return;
    }

    // Record in backend log.
    this.apiClient.frontendLog(`${message}: ${details}.`, stack)
        .catch(error2 => console.error("Failed to log to backend: " + error2));
  }
}
